export function getUrlParts(url) {
    /* https://gist.github.com/jlong/2428561 */
    const parser = document.createElement('a');
    let pathname = '';
    
    parser.href = url || window.location.href;
    pathname = parser.pathname;
    
    /* check origin and pathname for IE */
    if (!parser.origin) {
        parser.origin = parser.protocol + '//' + parser.hostname;
    }
    
    if (pathname[0] !== '/') {
        pathname = '/' + pathname;
    }
    
    return {
        protocol: parser.protocol, /* => "http:" */
        hostname: parser.hostname, /* => "example.com" */
        port: parser.port, /* => "3000" */
        pathname: pathname, /* => "/pathname/" */
        search: parser.search, /* => "?search=test" */
        hash: parser.hash,  /* => "#hash" */
        host: parser.host, /* => "example.com:3000" */
        origin: parser.origin /* => "http://example.com" */
    };
}